import React, {Component} from 'react';

import foodImage from "../../Assets/foodImage.svg";
import bhajiImage from "../../Assets/bhajiImage.svg";
import cardCarbs from "../../Assets/cardCarbs.svg";
import cardTime from "../../Assets/cardTime.svg";
import { toHaveAccessibleDescription } from '@testing-library/jest-dom/dist/matchers';

// FoodSectionMainPage Component
export default class RecipeCard extends Component {
  
  // back to main page
  renderPage = () => {

    this.props.changePage();
  }

    // Low Carbs Component
    lowCarbsCard() {
      return (
        <div className="FoodSection_FoodCard">
          <img src={foodImage} alt="Food Image" />
          <div className="FoodSection_FoodDetails">
            <div className="FoodSection_FoodName">Poha</div>
            <div className="FoodSection_CarbsBtn">
              <div className="FoodSection_Carb">28gm</div>
              <button className="FoodSection_Btn" onClick={() => this.renderPage()}></button>
            </div>
          </div>
        </div>
      );
    }
  
  
    // Menu Component
    menu(name) {
      return (
        <div className="FoodSection_Menu">
          <div className="FoodSection_MenuName">{name}</div>
        </div>
      );
    }
  
    // NormalCarbs Card Component 
    normalCarbsCard(name) {
      return (
        <div className="FoodSection_NFCard">
          <div className="FoodSection_NFImg">
            <img src={bhajiImage} />
          </div>
          <div className="FoodSection_NFDetails">
            <div className="FoodSection_NFName">{name}</div>
            <div className="FoodSection_NFPara">
              <div
                className="FoodSection_NFCarbs"
                style={{ backgroundImage: `url(${cardCarbs})` }}
              >
                28gm
              </div>
              <div
                className="FoodSection_NFTime"
                style={{ backgroundImage: `url(${cardTime})` }}
              >
                28 min
              </div>
            </div>
            <button className="FoodSection_NFBtn" onClick={() => this.renderPage()}>View Recipe</button>
          </div>
        </div>
      );
    }
  
    render() {
      return (
        <>
          <div className="FoodSection_MainTitle">Search Your Favorite Food</div>
          <div className="FoodSection_SearchBarBlock">
            <input
              className="FoodSection_SearchBar"
              CF
              type="search"
              placeholder="Search Food"
            />
          </div>
          <div className="FoodSection_PopularFoodBlock">
            <div className="FoodSection_PFTitle">Popular Low Carbs Food</div>
            <div className="FoodSection_PFCards">
              {this.lowCarbsCard()}
              {this.lowCarbsCard()}
              {this.lowCarbsCard()}
              {this.lowCarbsCard()}
              {this.lowCarbsCard()}
              {this.lowCarbsCard()}
              {this.lowCarbsCard()}
              {this.lowCarbsCard()}
              {this.lowCarbsCard()}
              {this.lowCarbsCard()}
            </div>
          </div>
          <div className="FoodSection_CategoryFoodBlock">
            <div className="FoodSection_CFTitle">Category</div>
            <div className="FoodSection_CFMenu">
              {this.menu("Chapati")}
              {this.menu("Chapati")}
              {this.menu("Chapati")}
              {this.menu("Chapati")}
              {this.menu("Chapati")}
              {this.menu("Chapati")}
              {this.menu("Chapati")}
            </div>
            <div className="FoodSection_CFCards">
              {this.normalCarbsCard("Methi")}
              {this.normalCarbsCard("Methi")}
              {this.normalCarbsCard("Methi")}
              {this.normalCarbsCard("Methi")}
              {this.normalCarbsCard("Methi")}
              {this.normalCarbsCard("Methi")}
            </div>
          </div>
        </>
      );
    }
  }